module.exports = __webpack_public_path__ + "media/img/marking-db8a60f7945d989a72fa9217f4324026.png";